import coreModules from './coreModules';
import advancedModules from './advancedModules';
import legacyModules from './legacyModules';

export const MODULE_COMPONENT_REGISTRY = {
  core: coreModules,
  advanced: advancedModules,
  legacy: legacyModules,
};

export const getModuleRegistration = (type) => {
  for (const [tier, components] of Object.entries(MODULE_COMPONENT_REGISTRY)) {
    if (components[type]) {
      return { tier, Component: components[type] };
    }
  }
  return { tier: 'unknown', Component: null };
};

export default MODULE_COMPONENT_REGISTRY;
